<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    // getBanks () {
    //   this.$store.dispatch('getBanks')
    // },

    // getAgreements () {
    //   this.$store.dispatch('getAgreements')
    // },

    getAdvisors () {
      this.$store.dispatch('getAdvisors')
    },

    getUsers () {
      this.$store.dispatch('getUsers')
    },

    getTags () {
      this.$store.dispatch('getTags')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    },

    getPrefs () {
      this.$store.dispatch('getPrefs')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getBanks()
      // vm.getAgreements()
      vm.getAdvisors()
      vm.getUsers()
      vm.getTags()
      vm.getOffices()
      vm.getPrefs()
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Agreements.vue?ae1e2df0